// generated by tools/generate-app-commit.mjs — do not edit
export const APP_COMMIT='688d25b';
